import { z } from "zod";

export const rampCreateConnectionBodySchema = z.object({
    code: z.string(),
    defaultEntityId: z.number().int().optional(),
});

export type RampCreateConnectionBody = z.infer<
    typeof rampCreateConnectionBodySchema
>;
